export const normalise = (current: number, max: number) => {
  const p = (100 * current) / max
  if (p > 100) {
    return 100
  } else {
    return p
  }
}